import { createContext } from "react";
import { UserDto } from "../api/data-contracts";

interface UserCtx {
  user: UserDto | undefined;
  setUser: (user: UserDto) => void;
}

const UserContext = createContext<UserCtx>({
  user: undefined,
  setUser: (user: UserDto) => user,
});

export default UserContext;
